import React from 'react';
import { Input, InputProps } from '../ui/input';
import { Mail, CheckCircle2 } from 'lucide-react';
import { cn } from '../../lib/utils';

interface InputEmailProps extends InputProps {
    isValid?: boolean;
}

export const InputEmail: React.FC<InputEmailProps> = ({
    className,
    isValid,
    ...props
}) => {
    return (
        <div className="relative">
            <div className="absolute left-4 top-1/2 -translate-y-1/2 text-text-muted">
                <Mail className="w-5 h-5" />
            </div>
            <Input
                type="email"
                placeholder="nombre@empresa.com"
                className={cn(
                    "pl-11 h-[50px]", // Padding for icon
                    isValid && "border-success-text/50 bg-success-bg/10 pr-10",
                    className
                )}
                {...props}
            />
            {isValid && (
                <div className="absolute right-4 top-1/2 -translate-y-1/2 text-success-text animate-zoom-in">
                    <CheckCircle2 className="w-5 h-5" />
                </div>
            )}
        </div>
    );
};
